import { Component, OnInit } from '@angular/core';

import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { AdminService } from '../../services/admin.service';
import { SessionService } from '../../services/session2.service';
import { ServiceWorkerService } from '../../services/sw.service';
import { UserService } from 'app/services/user.service';

@Component({
  selector: 'app-admin-web-push',
  templateUrl: './admin-web-push.component.html'
})
export class AdminWebPushComponent implements OnInit {

  pushTestPending: boolean = false;

  email: string = '';
  title: string = '';
  body: string = '';
  url: string = '';
  requireInteraction: boolean = false;

  constructor(private cacheService: CacheService,
              private sessionService: SessionService,
              private adminService: AdminService,
              private userService: UserService,
              private serviceWorkerService: ServiceWorkerService) { }

  ngOnInit() {
    if (!this.cacheService.get('session')) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.initView();
        }
      );
    }
    else {
      this.initView();
    }
  }

  private initView() {
    // empty
  }

  toggleRequireInteraction() {
    this.requireInteraction = !this.requireInteraction;
  }

  testNotification() {
    this.pushTestPending = true;
    this.serviceWorkerService.sendTestNotification(this.email, {
      message: {
        title: this.title,
        body: this.body,
        onClickUrl: this.url,
        requireInteraction: this.requireInteraction,
      }
    }).subscribe(
      () => this.pushTestPending = false,
      () => this.pushTestPending = false
    );
  }

}



// WEBPACK FOOTER //
// ./client/app/admin/admin-web-push/admin-web-push.component.ts